import { Link as RouterLink } from 'react-router-dom';
import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { usePalette } from 'src/hooks';

interface Props extends MuiLinkProps {
  type?: 'default' | 'href';
  to: string;
  headerStyles?: boolean;
}

export const Link = ({ type = 'default', headerStyles = false, to, sx, children, ...props }: Props) => {
  const { primary } = usePalette();

  const sharedProps = {
    variant: 'body2',
    underline: 'hover',
    color: 'inherit',
    sx
  } as const;

  const sharedHeaderProps =
    headerStyles &&
    ({
      variant: 'body1',
      sx: { fontFamily: 'PoppinsBold', color: primary.main, ...sx }
    } as const);

  if (type === 'href') {
    return (
      <MuiLink component='a' href={to} target='_blank' {...sharedProps} {...sharedHeaderProps} {...props}>
        {children}
      </MuiLink>
    );
  }

  return (
    <MuiLink component={RouterLink} to={to} {...sharedProps} {...sharedHeaderProps} {...props}>
      {children}
    </MuiLink>
  );
};
